"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROUTE = exports.paramsSchema = void 0;
var yup = __importStar(require("yup"));
var constants_1 = require("../../../constants");
exports.paramsSchema = yup.object().shape({
    photo: yup
        .mixed()
        .test('content_type', 'file is not an image', function (value) {
        var imageMagicNumber = {
            jpg: 'ffd8ffe0',
            jpg1: 'ffd8ffe1',
            jpg2: 'ffd8ffe2',
            jpg3: 'ffd8ffe8',
            png: '89504e47',
        };
        return value && typeof value === 'object'
            ? Object.values(imageMagicNumber).includes(value.buffer.toString('hex', 0, 4))
            : true;
    })
        .test('mimetype', 'unsupported file format', function (value) {
        return value && typeof value === 'object'
            ? ['image/png', 'image/jpeg'].includes(value.mimetype || value.type)
            : true;
    })
        .test('size', 'file is too large', function (value) {
        return value && typeof value === 'object' ? value.size <= 10 * 1024 * 1024 : true;
    })
        .required('Required'),
});
exports.ROUTE = constants_1.routes.CLIENT_FORM_UPLOAD_PHOTO;
//# sourceMappingURL=params.js.map